import React, { useState } from 'react';
import './FilterComponent.css';

const FilterComponent = ({
  placeHolder,
  showTermFilter,
  showStartDate=false,
  showEndDate=false,
  submitFilter=false,
  exportFunction,
  initialTerm = '',
  initialStartDate = '',
  initialEndDate = '',
  initialStatus = '',
  statusOptions = []
}) => {
  const [term, setTerm] = useState(initialTerm || '');
  const [startDate, setStartDate] = useState(initialStartDate || '');
  const [endDate, setEndDate] = useState(initialEndDate || '');
  const [status, setStatus] = useState(initialStatus || '');
  
  const handleSubmit = () => {
    submitFilter({
      term: term || undefined,
      startDate: startDate || undefined,
      endDate: endDate || undefined,
      status: status || undefined
    });
  };

  const exportReport = () => {
    exportFunction(term || undefined, startDate || undefined, endDate || undefined);
  };

  return (
    <div className="filter-container">
      <div className='filter-container-main'>
        <div className='filter-itens'>
          <div className='filter-basic'>
            {showTermFilter && (
              <div className='filter-basic-item'>
                <span>Filtro</span>
                <input
                  type="text"
                  placeholder={placeHolder}
                  className="main-input"
                  value={term}
                  onChange={(e) => setTerm(e.target.value)}
                />
              </div>
            )}
            {showStartDate && (
              <div className='filter-basic-item'>
                <span>Data Inicial</span>
                <input
                  type="date"
                  placeholder="Data Inicial"
                  className="main-input"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
            )}
            {showEndDate && (
              <div className='filter-basic-item'>
                <span>Data Final</span>
                <input
                  type="date"
                  placeholder="Data Final"
                  className="main-input"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            )}
            {statusOptions.length > 0 && (
              <div className='filter-basic-item'>
                <span>Status</span>
                <select
                  className="main-input"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="">Todos</option>
                  {statusOptions.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
            )}
          </div>
        </div>

        <div className='filter-buttons'>
          <button onClick={handleSubmit} className="main-button margin-top-default">
            Filtrar
          </button>
          {
            exportFunction && (
              <button onClick={exportReport} className="main-button margin-top-default">
                Exportar
              </button>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default FilterComponent;
